<template>
  <div style="padding: 20px 0 0 0">
    <el-form :inline="true" :model="formInline" label-position="left" @keydown.native.enter="onSubmit"
      class="demo-form-inline">
      <el-form-item label="物流单号：">
        <div @dblclick="openBatchSearch" v-if="tableType === 'ToBeProduced' && prentType === 'small'">
          <el-select v-model="formInline.logisticsCodeList" multiple filterable allow-create collapse-tags>
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <el-input maxlength='50' v-model="formInline.logisticsCode" placeholder="请填入物流单号" v-else></el-input>
      </el-form-item>
      <el-form-item label="发货编号：">
        <el-input maxlength='50' v-model="formInline.deliveryTaskCode" placeholder="请填入发货编号"></el-input>
      </el-form-item>
      <el-form-item label="货代公司：">
        <el-select v-model="formInline.wmsForwarder" placeholder="全部" filterable>
          <el-option label="全部" :value="''"></el-option>
          <el-option :label="item.forwarder + `(${item.currentAmount})`"
            :title="item.forwarder + `(${item.currentAmount})`" :value="item.forwarder" :disabled="!item.currentAmount"
            v-for="(item, index) in forwarderCompany" :key="index" v-if="item.currentAmount > 0" />
        </el-select>
      </el-form-item>
      <el-form-item label="货代渠道：">
        <el-select v-model="formInline.forwarderConfigId" placeholder="全部" filterable>
          <el-option label="全部" :value="''"></el-option>
          <el-option :label="item.forwarder + '-' + item.shippingType + `(${item.currentAmount})`"
            :title="item.forwarder + '-' + item.shippingType + `(${item.currentAmount})`"
            :value="item.intForwarderConfigId" :disabled="!item.currentAmount" v-for="(item, index) in forwarder"
            :key="index" v-if="item.currentAmount > 0" />
        </el-select>
      </el-form-item>
      <el-form-item label="下单账户主体：" v-if="prentType === 'small'">
        <el-input maxlength='50' v-model="formInline.logisticsCustomerName" placeholder="请填入下单账户主体"></el-input>
      </el-form-item>
      <el-form-item label="制作人：" v-if="tableType == 'AlreadyProduced' && prentType != 'small'">
        <el-input maxlength='50' v-model="formInline.operatorName" placeholder="请填入制作人"></el-input>
      </el-form-item>
      <el-form-item label="创建日期：">
        <el-date-picker v-model="formInline.createDate" type="daterange" range-separator="至" start-placeholder="开始日期"
          @change="timeChange" end-placeholder="结束日期"> </el-date-picker>
      </el-form-item>
      <el-form-item label="发货日期：">
        <el-date-picker v-model="formInline.deliveryTime" type="daterange" range-separator="至" start-placeholder="开始日期"
          @change="deliveryTimeChange" end-placeholder="结束日期"> </el-date-picker>
      </el-form-item>
      <el-form-item label="平台SKU：" v-if="prentType != 'small'">
        <el-input maxlength='100' v-model="formInline.productSku" placeholder="请填入平台SKU"></el-input>
      </el-form-item>
      <el-form-item label="商品SKU：" v-if="prentType != 'small'">
        <el-input maxlength='100' v-model="formInline.shopProductSku" placeholder="请填入商品SKU"></el-input>
      </el-form-item>
      <el-form-item>
        <el-checkbox v-model="formInline.needRefundTaxFlag_boolean">需退税商品</el-checkbox>
      </el-form-item>
      <el-form-item v-if="prentType == 'small' && tableType !== 'AlreadyProduced'">
        <el-checkbox v-model="formInline.mergeFlag">合单发货</el-checkbox>
      </el-form-item>
      <el-form-item v-if="prentType == 'small' && tableType !== 'AlreadyProduced'">
        <el-checkbox v-model="formInline.skuQuantityExceeds">sku数超限制数</el-checkbox>
      </el-form-item>
      <el-form-item v-if="prentType != 'small'">
        <el-checkbox :true-label="1" :false-label="0" v-model="formInline.needFullDeclarationFlag">需全量申报</el-checkbox>
      </el-form-item>
      <el-form-item>
        <template v-if="tableType == 'ToBeProduced' && prentType == 'small'">
          <!-- <el-button type="primary" @click="openConfig"
            style="margin-right: 10px;">基础配置</el-button> -->
          <el-dropdown trigger="click" placement="bottomLeft">
            <el-button type="primary" style="margin-right: 100px;" :loading="loading">
              制作（{{ selectedRows.length }}条）<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown" style="top:32px">
              <el-dropdown-item :disabled="selectedRows.length === 0">
                <div @click="openDo(1)">制作选择（{{ selectedRows.length }}条）</div>
              </el-dropdown-item>
              <el-dropdown-item :disabled="logList.length === 0">
                <div @click="openDo(2)">
                  制作全部（{{ logList.length }}条）
                </div>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
        <el-button type="primary" @click="onSubmit">查询</el-button>
        <el-button @click="restSubmit">重置</el-button>
      </el-form-item>
    </el-form>
    <el-dialog :close-on-click-modal="false" title="基础配置" :visible.sync="visible" width="1260px" @close="formClose">
      <div v-for="i, formIndex in configList" :key="formIndex" class="formBox">
        <el-form :inline="true" :model="i" label-position="left" ref="configForm" :rules="checkRules">
          <el-form-item label="货代渠道:" prop="wmsIntForwarderConfigId">
            <el-select v-model="i.wmsIntForwarderConfigId" placeholder="请选择" filterable
              @change="formForwardChange(formIndex)">
              <el-option :label="item.forwarder + '-' + item.shippingType"
                :title="item.forwarder + '-' + item.shippingType" :value="item.intForwarderConfigId"
                v-for="(item, index) in forwarder" :key="index" />
            </el-select>
            <div class="tips" v-if="errorList.some(v => v == formIndex)">货代渠道和仓库不能都相同</div>
          </el-form-item>
          <el-form-item label="国家:" prop="country">
            <el-input maxlength='50' v-model="i.country" placeholder="" :disabled="true"
              style="width: 120px;"></el-input>
            <!-- <el-select v-model="i.countryCode" placeholder="全部" filterable multiple collapse-tags style="width: 120px;">
              <el-option :label="item.name" :value="item.code" v-for="(item, index) in countryList" :key="index" />
            </el-select> -->
          </el-form-item>
          <el-form-item label="仓库:" prop="warehouse">
            <el-select v-model="i.warehouse" placeholder="请选择" filterable style="width: 120px;">
              <el-option :label="item.wareName" :value="item.wareCode" v-for="(item, index) in warehouseList"
                :key="index" />
            </el-select>
          </el-form-item>
          <el-form-item label="制作时间:" prop="makeTime">
            <el-time-picker v-model="i.makeTime" :disabled="!i.wmsIntForwarderConfigId" value-format="HH:mm:ss"
              style="width: 120px;"></el-time-picker>
          </el-form-item>
          <el-form-item label="发票抬头:" prop="title">
            <el-input maxlength='50' v-model="i.title" placeholder="请填入发票抬头"
              :disabled="!i.wmsIntForwarderConfigId"></el-input>
          </el-form-item>
        </el-form>
        <i class="el-icon-circle-plus formAction" v-if="formIndex == 0" @click="addForm"></i>
        <i class="el-icon-circle-plus" v-if="formIndex != 0" style="opacity: 0;font-size: 20px;"></i>
        <i class="el-icon-remove formAction" @click="removeForm(formIndex)"></i>
      </div>
      <div style="text-align: right;margin-right: 48px;">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" @click="submitConfig">确定</el-button>
      </div>
    </el-dialog>
    <BatchModal ref="batchModal" @submit="submitBatch" />
    <CreateInvoiceModal ref="createInvoiceModalRef" :clearSelect="clearSelect" />
  </div>
</template>

<script>
import moment from "moment"
import { updateD2cBaseConfig, getD2cBaseConfig, getInvoicePage } from '@/apis/outStock'
import BatchModal from "./BatchModal.vue";
import CreateInvoiceModal from "./CreateInvoiceModal.vue";
export default {
  name: "InterForm",
  components: {
    BatchModal,
    CreateInvoiceModal
  },
  props: {
    prentType: {
      type: String,
      required: true,
    },
    forwarder: {
      type: Array,
      default: () => []
    },
    forwarderCompany: {
      type: Array,
      default: () => []
    },
    tableType: {
      type: String,
      default: () => 'ToBeProduced'
    },
    selectedRows: {
      type: Array,
      default: () => []
    },
    clearSelect: {
      type: Function,
      default: () => ({})
    },
    isBatchSearch: {
      type: Boolean,
      default: false
    },
    logList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      loading:false,
      options: [],
      // storeList: [],
      formInline: {
        deliveryTaskCode: "",
        forwarderConfigId: '',
        wmsForwarder: '',
        logisticsCodeList: [],
        needFullDeclarationFlag: 0,
        mergeFlag: undefined,
        skuQuantityExceeds: undefined
      },
      visible: false,
      countryList: [],
      configList: [{
        country: '',
        countryCode: '',
        makeTime: '',
        title: '',
        warehouse: '',
        wmsForwarder: '',
        wmsIntForwarderConfigId: '',
        wmsShippingType: ''
      }],
      errorList: [],
      checkRules: {
        wmsIntForwarderConfigId: [{
          required: true, validator: (rule, value, callback) => {
            if (!value) {
              return callback(new Error('请选择货代'));
            }
            if (this.errorList.some(v => v == value)) {
              return callback(new Error('货代渠道和仓库不能都相同'));
            }
            callback();
          }
        }],
        // country:[{required: true}],
        warehouse: [{ required: true, message: '请选择仓库' }],
        makeTime: [{ required: true, message: '请选择制作时间' }],
        title: [{ required: true, message: '请输入发票抬头' }],
      }
    };
  },
  created() {
    this.$emit("querySubmit", this.formInline);
  },
  mounted() {
  },
  computed: {
    warehouseList: function () {
      return this.$store.getters.getWarehouses;
    },
  },
  watch: {
    configList: {
      immediate: true,
      deep: true,
      handler: function (newVal, oldVal) {
        if (newVal) {
          this.errorList = []
        }
      },
    },
  },
  methods: {
    openDo(type) {
      if(type === 1) {
        this.$refs.createInvoiceModalRef.open(this.selectedRows, type)
        return
      }
      this.loading = true
      // 根据参数打印先请求所有数据再打印
      getInvoicePage({
        pageNum: 1,
        pageSize: 10000,
        logisticsCodeList: this.logList,
        invoiceStatus: 0,
        deliveryType: 2
      }).then((res) => {
        console.log(res)
        if(!res.success) return
        this.$refs.createInvoiceModalRef.open(res.data?.records ?? [], type)
      }).finally(() => {
        this.loading = false
      })
    },
    submitBatch(v) {
      this.formInline.logisticsCodeList = [...v]
    },
    openBatchSearch() {
      this.$refs.batchModal.open(this.formInline.logisticsCodeList)
    },
    timeChange: function (val) {
      if (!val) {
        this.formInline.createStartTime = null;
        this.formInline.createEndTime = null;
        return;
      }
      this.formInline.createStartTime = moment(val[0]).format("YYYY-MM-DD 00:00:00");
      this.formInline.createEndTime = moment(val[1]).format("YYYY-MM-DD 23:59:59");
    },
    deliveryTimeChange: function (val) {
      if (!val) {
        this.formInline.deliveryStartTime = null;
        this.formInline.deliveryEndTime = null;
        return;
      }
      this.formInline.deliveryStartTime = moment(val[0]).format("YYYY-MM-DD 00:00:00");
      this.formInline.deliveryEndTime = moment(val[1]).format("YYYY-MM-DD 23:59:59");
    },
    onSubmit: function () {
      const form = {
        ...this.formInline,
        needRefundTaxFlag: this.formInline.needRefundTaxFlag_boolean ? 1 : undefined,
        mergeFlag: this.formInline.mergeFlag && this.tableType !== 'AlreadyProduced' ? 1 : undefined,
        skuQuantityExceeds: this.formInline.skuQuantityExceeds && this.tableType !== 'AlreadyProduced' ? 1 : undefined
      }
      this.$emit("querySubmit", form);
    },
    restSubmit: function () {
      Object.keys(this.formInline).forEach(key => {
        this.formInline[key] = key === 'logisticsCodeList' ? [] : undefined
        if(['needRefundTaxFlag_boolean', 'mergeFlag', 'skuQuantityExceeds'].includes(key)) {
          this.formInline[key] = false
        }
      })
      this.onSubmit(undefined, "rest");
    },
    openConfig() {
      getD2cBaseConfig().then(res => {
        if (res.code == 0 && res.data.length) {
          this.configList = res.data.map(v => {
            return {
              wmsIntForwarderConfigId: v.wmsIntForwarderConfigId,
              warehouse: v.warehouse,
              title: v.title,
              makeTime: v.makeTime,
              country: v.country
            }
          })
        }
        this.visible = true
      })
    },
    addForm() {
      this.configList.push({
        country: '',
        countryCode: '',
        makeTime: '',
        title: '',
        warehouse: '',
        wmsForwarder: '',
        wmsIntForwarderConfigId: '',
        wmsShippingType: ''
      })
      // const that = this
      // that.$nextTick(() => {
      //   that.$refs.configForm
      // })
    },
    removeForm(formIndex) {
      this.configList = this.configList.filter((v, i) => i != formIndex)
    },
    formForwardChange(formIndex) {
      this.configList[formIndex].country = this.forwarder.filter(v => v.intForwarderConfigId == this.configList[formIndex].wmsIntForwarderConfigId)[0].countryCnName
      this.configList[formIndex].countryCode = this.forwarder.filter(v => v.intForwarderConfigId == this.configList[formIndex].wmsIntForwarderConfigId)[0].countryCode
      this.configList[formIndex].wmsForwarder = this.forwarder.filter(v => v.intForwarderConfigId == this.configList[formIndex].wmsIntForwarderConfigId)[0].forwarder
      this.configList[formIndex].wmsShippingType = this.forwarder.filter(v => v.intForwarderConfigId == this.configList[formIndex].wmsIntForwarderConfigId)[0].shippingType
    },
    submitConfig() {
      this.errorList = []
      const validateList = this.$refs.configForm.map(v => {
        return v.validate()
      })
      Promise.all(validateList).then(() => {
        this.configList.forEach((v, i) => {
          if (this.configList.filter(y => y.wmsIntForwarderConfigId == v.wmsIntForwarderConfigId && y.warehouse == v.warehouse).length > 1) {
            this.errorList.push(i)
          }
        })
        if (this.errorList.length > 0) {
          return
        }
        const params = this.configList.map(v => {
          return {
            ...v,
          }
        })
        updateD2cBaseConfig(params).then(res => {
          console.log(res)
          if (res.code == 0) {
            this.$message.success('成功')
            this.visible = false
          }
        })
      })
    },
    formClose() {
      this.configList = [{
        country: '',
        countryCode: '',
        makeTime: '',
        title: '',
        warehouse: '',
        wmsForwarder: '',
        wmsIntForwarderConfigId: '',
        wmsShippingType: ''
      }]
      this.$refs.configForm.forEach(v => {
        v.clearValidate()
      })
    }
  }
};
</script>

<style scoped>
.demo-form-inline {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.formBox {
  display: flex;
  /* align-items: center; */
  justify-content: center;
  margin-bottom: 12px
}

.formAction {
  font-size: 20px;
  position: relative;
  top: 8px;
}

.tips {
  position: absolute;
  left: -80px;
  top: 36px;
  color: #F56C6C;
  font-size: 12px;
  line-height: 1;
}
</style>
